jQuery(document).ready($ => {
	$(document).on('submit_success', (event, response) => {
		if( 'undefined' !== typeof response.data.whippetHideForm && response.data.whippetHideForm ) {
			const fieldsWrapper = event.target.querySelector( '.elementor-form-fields-wrapper' );
			
			if( fieldsWrapper ) {
				fieldsWrapper.hidden = true;
			}

			event.target.scrollIntoView( {
				block: 'center',
			} );
		}
	});
});
